// Bank Name
export const billingReportListApi = 'billing-information-management/billing-report/list'
export const billingReportStoreApi = 'billing-information-management/billing-report/store'
export const billingReportUpdateApi = 'billing-information-management/billing-report/update'
export const billingReportToggleStatusApi = 'billing-information-management/billing-report/toggle-status'
export const billingReportVerifieStatusApi = 'billing-information-management/billing-report/verifie-status'
export const billingReportAssignHosDeptApi = 'billing-information-management/billing-report/assign-hos-dept'
export const billingReportApi = 'billing-information-management/billing-report/report-list'
export const billingReportHospitalWiseApi = 'billing-information-management/billing-report/report-hos-list'
export const assignUserHospitalApi = 'configuration/hospital/user-hospital'
